import { usePage } from "@inertiajs/react"

import type { PlanTier, SharedData } from "@/types"

export function useSubscription() {
  const { auth } = usePage<{ auth: SharedData["auth"] }>().props

  const subscription = auth?.subscription
  const billingSubscription = auth?.billing_subscription ?? subscription
  const needsPaymentUpdate = auth?.user?.needs_payment_update === true || billingSubscription?.needs_payment_update === true
  const billingProvider = billingSubscription?.billing_provider ?? null

  return {
    subscription,
    billingSubscription,
    isSubscribed: !!subscription,
    isTrialing: subscription?.trialing ?? false,
    planId: subscription?.plan_id ?? null,
    planName: subscription?.plan_name ?? null,
    tier: subscription?.tier ?? null as PlanTier | null,
    status: subscription?.status ?? null,
    features: subscription?.features ?? { live_online: false, replays: false, mudras: false },
    canAccessLiveOnline: subscription?.features?.live_online ?? false,
    canAccessReplays: subscription?.features?.replays ?? false,
    canAccessMudras: subscription?.features?.mudras ?? false,
    trialEndsAt: subscription?.trial_ends_at ? new Date(subscription.trial_ends_at) : null,
    currentPeriodEnd: subscription?.current_period_end ? new Date(subscription.current_period_end) : null,
    cancelAtPeriodEnd: subscription?.cancel_at_period_end ?? false,
    billingIntervalLabel: subscription?.billing_interval_label ?? null,
    billingProvider,
    needsPaymentUpdate,
    hasBillingSubscription: !!billingSubscription,
    // Tier helpers
    isSilver: subscription?.tier === "silver",
    isGold: subscription?.tier === "gold",
  }
}
